import { createFileRoute } from '@tanstack/react-router'
import { KbArticleView } from '@/features/kb/KbArticleView'

function ArticleRoute() {
  const { slug } = Route.useParams()
  return <KbArticleView slug={slug} />
}

export const Route = createFileRoute('/kb/$slug')({ component: ArticleRoute })
